import React from 'react';

import { createIcimRedirectURL } from '../../helpers/api/user-profile-api';
import { isBrowser } from '../../helpers/is-browser';
import { setLocalStorageItem } from '../../helpers/utils';
import { useGetLibraryConstantsDictionary } from '../../hooks/use-get-library-constants-dictionary';
import LinkButton from '../ui/link-button/link-button';

interface LoginRegisterProps {
  node_locale: string;
  brandId: string;
  current_path?: string;
}

const LoginRegister: React.FC<LoginRegisterProps> = ({
  node_locale,
  brandId,
}) => {
  const ICIM_URL = createIcimRedirectURL(node_locale, brandId);
  const dictionary = useGetLibraryConstantsDictionary(node_locale);

  const signInBUttonClickHanlder = () => {
    if (isBrowser) {
      const params = new URLSearchParams(window.location.search);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      setLocalStorageItem('current_path', newUrl);
    }
  };

  return (
    <div className="max-w-md mx-auto my-12">
      <h2 className="text-headingm font-title lg:text-headingxl mb-6 text-text-default text-center lg:text-start">
        {dictionary?.siezeThePerks}
      </h2>
      <p className="text-bodyl text-text-default mb-6">
        {dictionary?.joinOrSignIn}
      </p>
      <LinkButton
        to={ICIM_URL}
        variant="primary"
        className="w-full text-center mt-8 mb-6"
        isExternalLink
        size="regular"
        onClickHandler={signInBUttonClickHanlder}
      >
        {dictionary?.logInOrSignInButtonText}
      </LinkButton>
    </div>
  );
};

export default LoginRegister;
